var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-content"},[(_vm.detail)?_c(_vm.comName,{tag:"components",attrs:{"examInfo":_vm.examInfo,"detail":_vm.detail,"info":_vm.info}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }